import React, { useEffect } from 'react'
import useNewItemChange from '../../../../../../../../../EHR/EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import ValidationText from '../../../../../../../../../EHR/EHR Settings/Templates/OpenTemplate/FormBuilder/Items/ValidationText';
// import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
import { Separator } from '../../../../../../../../../EHR/utils/utils';
import ShowItemContent from './ShowItemContent';

const SingleChoice = ({ item, setItem, activeAccordion, validations, isGroupNote, ...props }) => {
    // Parse options from item.content (split by new lines)
    const { handleSelectSingleOptionNew, handleViewerHintTextChange } = useNewItemChange(setItem, 'Viewer', activeAccordion);
    const options = item.options ? item.options.split(Separator) : [];
    const key = `${props?.itemRefKey}${item?.ItemID}`;

    // useEffect(() => {
    //     const existingSelectedOptions = item.selectedOptions?.split(Separator) || [];
    //     const currentSelected = existingSelectedOptions.map(option => option.split('(D)')[0]);
    //     if (JSON.stringify(currentSelected) === JSON.stringify(options)) {
    //         return; // No change
    //     }

    //     setItem(prev => {
    //         return prev.map(section => {
    //             if (section.key === activeAccordion) {
    //                 const updatedItems = section.items.map(currItem => {
    //                     if (currItem.ItemID === item.ItemID) {
    //                         const list = options.join(Separator);
    //                         return { ...currItem, selectedOptions: list };
    //                     }
    //                     return currItem;
    //                 });
    //                 return { ...section, items: updatedItems };
    //             }
    //             return section;
    //         });
    //     });
    // }, []);

    // Parse options properly: label, checked, TR flag, hintText text
    const selectedOptions =
        (item.selectedOptions?.split(Separator) || []).length > 0
            ? (item.selectedOptions?.split(Separator) || []).map(optStr => {
                const hasSelected = optStr.includes("(D)");
                const baseLabel = optStr.split("(D)")[0].split("[")[0];

                const metaMatch = optStr.match(/\[(.*?)\]/);
                let textResponse = "false";
                let hintText = "";
                let value = "";

                if (metaMatch) {
                    const parts = metaMatch[1].split("|");
                    parts.forEach(p => {
                        if (p.startsWith("TR=")) textResponse = p.split("=")[1];
                        if (p.startsWith("hintText=")) hintText = p.split("=")[1].replace(/'/g, "");
                        if (p.startsWith("value=")) value = p.split("=")[1].replace(/'/g, "");
                    });
                }

                return {
                    content: baseLabel,
                    checked: hasSelected,
                    textResponse: textResponse,
                    hintText: hintText,
                    value: value
                };
            })
            : [];
    console.log("validationItemsModal  SingleChoice 2", validations)
    return (
        <>
            <div className="d-flex gap-10">
                <div className="ar-form-counter flex-center">
                    <p className='text text-black'>{props?.itemCount}</p>
                </div>
                <div className='content-box d-flex flex-column gap-6 w-100'>
                    <p className={`heading fs-13 d-flex gap-01 ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
                        {/* {item.content || '[Insert prompt or question]'} */}
                        {ShowItemContent(item, isGroupNote)}
                        {/* \\ Required icon commented \\ */}
                        {/* {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>} */}
                    </p>
                    <div className="d-flex flex-column gap-6 w-100">
                        <div className="d-flex gap-16 align-items-center row-gap-8 flex-wrap">
                            {selectedOptions.length > 0 &&
                                selectedOptions.map((option, index) => (
                                    <React.Fragment key={index}>
                                        <div className={`d-flex flex-column gap-2 ${option.checked && option.textResponse === "true" ? 'w-100' : ''}`}>
                                            <label className='ar_radio-btn d-flex align-items-center gap-6'>
                                                <div className='custom_check_box d-flex checkbox-multiline-alignment gap-6'>
                                                    <input
                                                        type="radio"
                                                        className="form-check-input mt-0"
                                                        id={`checklist-${index}-${key}`}
                                                        checked={option.checked}
                                                        onChange={(e) => { e.stopPropagation(); handleSelectSingleOptionNew(item, index) }}
                                                    // disabled
                                                    />
                                                    <p className="text ar-orange-text" htmlFor={`checklist-${index}-${key}`}>
                                                        {option.content || '[Insert Option]'}
                                                    </p>
                                                </div>
                                            </label>

                                            {option.checked && option.textResponse === "true" && (
                                                <div className={`input ${validations?.optionValidations?.[index] ? 'error' : ''}`}>
                                                    <input
                                                        type="text"
                                                        className='form-control height-30'
                                                        id='value'
                                                        name='value'
                                                        value={option?.value || ''}
                                                        placeholder={option.hintText}
                                                        // onChange={handleChangeHintText}
                                                        onChange={e => handleViewerHintTextChange(e, item, index)}
                                                    />
                                                    <ValidationText name={'Option'} validations={validations} />
                                                </div>
                                            )}
                                        </div>

                                    </React.Fragment>
                                ))}
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};
export default SingleChoice